const cleanUpStringParam = (name: string): string => {
    // Remove leading and trailing whitespace
    // Replace slashes with dashes - this is a convention used in tracking event names
    return name.trim().replace(/\//g, "-");
};

function cleanUpParam<P>(param: P): P {
    if (typeof param === "string") {
        return cleanUpStringParam(param) as P;
    }

    return param;
}

const createSiTrackingEventName = (...params: ReadonlyArray<unknown>): string => {
    return params
        .filter((param) => param !== undefined && param !== "")
        .map(cleanUpParam)
        .join("/");
};

export default createSiTrackingEventName;
